<template>
  <div class="icon-info-box desktop-wide">
    <div class="icon-info-box__circle">
      <ScImage class="icon-info-box__icon" :media="fields.IconInfoImage" />
    </div>

    <div class="icon-info-box__wrapper">
      <ScText tag="h6" class="icon-info-box__title" :field="fields.IconInfoTitle" />
      <ScText tag="p" class="icon-info-box__text" :field="fields.IconInfoText" />
    </div>
  </div>
</template>

<script>
import { Text, Image } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'IconInfoBox',
  components: {
    ScText: Text,
    ScImage: Image,
  },
  props: {
    fields: {
      type: Object,
    },
  },
};
</script>

<style lang="scss">
.icon-info-box {
  display: flex;
  flex-direction: row;
  background: #{$color-white};
  border: 1px solid #{$color-grey};
  border-radius: 16px;
  position: relative;
  padding: 16px 24px 16px 36px;
  margin: 16px 0 24px 20px;

  &__circle {
    align-self: center;
    height: 40px;
    width: 40px;
    background: #{$color-blue};
    border-radius: 50%;
    position: absolute;
    left: -20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__icon {
    width: 24px;
    height: 24px;
  }

  &__title {
    font-size: 18px;
    line-height: 1.6;
  }

  &__text {
    font-size: 16px;
    color: #{$color-grey-darker};

    @include desktop {
      font-size: 17px;
      line-height: 1.55;
    }
  }
}
</style>
